import { Behavior } from '@/model';

export class ReadonlyBehavior extends Behavior {
  override onLoad(): void {}
  override onUnload(): void {}
}
